import { orange, blue, blueGrey } from "@mui/material/colors";
const primary = {
    light: orange[50],
    main: orange[100],
    dark: orange[300]
};
const secondary = {
    light: blue["A100"],
    main: blue["A100"],
    dark: blue["A400"]
};
const background = {
    default: blueGrey[800],
    paper: blueGrey[900]
};
const dark = {
    mode: "dark",
    primary,
    secondary,
    background,
    destructive: secondary,
    quarternary: secondary,
    ghostGray: secondary,
    ghostPrimary: secondary,
    linkGray: secondary,
    linkPrimary: secondary,
    none: secondary,
    gray: secondary,
    tertiary: secondary,
    neutral: secondary
};
export default dark;

//# sourceMappingURL=index.js.map